export default function navigateWithAnalytics(
    href,
    ctaText = "navigate",
    initiator = "user",
    replace = true
) {
    window.__analytics_queue__ = window.__analytics_queue__ || [];

    // push analytics event synchronously (before the hard nav)
    window.__analytics_queue__.push({
        event: "aa-link",
        data: {
            link_text: ctaText,
            link_href: href,
            link_trigger: "aa-link",
        },
    });

    if (replace) {
        window.location.replace(href);
    } else {
        window.location.assign(href);
    }
}